import { AuthState } from '@okta/okta-auth-js';

import { User } from '../../services/backend/User';
import { useBaseApiClient } from '../useBaseApiClient';

export const useUser: () => User<AuthState> = () => {
  return useBaseApiClient(User);
};
